import React, { useState, useEffect, useCallback } from 'react';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';

const ICONES = {
  sucesso: <CheckCircle size={18} />,
  erro:    <XCircle size={18} />,
  aviso:   <AlertTriangle size={18} />,
  info:    <Info size={18} />,
};

const CORES = {
  sucesso: { bg: 'rgba(16,185,129,0.12)', border: 'rgba(16,185,129,0.35)', icon: '#10b981', texto: '#6ee7b7' },
  erro:    { bg: 'rgba(239,68,68,0.12)',  border: 'rgba(239,68,68,0.35)',  icon: '#ef4444', texto: '#fca5a5' },
  aviso:   { bg: 'rgba(245,158,11,0.12)', border: 'rgba(245,158,11,0.35)', icon: '#f59e0b', texto: '#fcd34d' },
  info:    { bg: 'rgba(59,130,246,0.12)', border: 'rgba(59,130,246,0.35)', icon: '#3b82f6', texto: '#93c5fd' },
};

let idCounter = 0;

export function Toaster() {
  const [toasts, setToasts] = useState([]);

  const remover = useCallback((id) => {
    setToasts(prev => prev.map(t => t.id === id ? { ...t, saindo: true } : t));
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 350);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      const { mensagem, tipo } = e.detail;
      const id = ++idCounter;
      setToasts(prev => [...prev, { id, mensagem, tipo, saindo: false }]);
      setTimeout(() => remover(id), 4000);
    };
    window.addEventListener('kzero-toast', handler);
    return () => window.removeEventListener('kzero-toast', handler);
  }, [remover]);

  if (!toasts.length) return null;

  return (
    <div style={s.container}>
      {toasts.map(t => {
        const cor = CORES[t.tipo] || CORES.sucesso;
        return (
          <div
            key={t.id}
            style={{
              ...s.toast,
              background: cor.bg,
              border: `1px solid ${cor.border}`,
              opacity: t.saindo ? 0 : 1,
              transform: t.saindo ? 'translateX(110%)' : 'translateX(0)',
            }}
          >
            <span style={{ color: cor.icon, display: 'flex', flexShrink: 0 }}>
              {ICONES[t.tipo] || ICONES.sucesso}
            </span>
            <span style={{ ...s.mensagem, color: cor.texto }}>{t.mensagem}</span>
            <button style={s.btnFechar} onClick={() => remover(t.id)}>
              <X size={13} />
            </button>
          </div>
        );
      })}
    </div>
  );
}

const s = {
  container: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    pointerEvents: 'none',
  },
  toast: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    borderRadius: 12,
    padding: '12px 14px',
    minWidth: 260,
    maxWidth: 400,
    backdropFilter: 'blur(10px)',
    boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
    transition: 'opacity 0.3s ease, transform 0.3s ease',
    pointerEvents: 'all',
  },
  mensagem: {
    fontSize: 13,
    fontWeight: 500,
    flex: 1,
    lineHeight: 1.4,
  },
  btnFechar: {
    background: 'transparent',
    border: 'none',
    color: '#5f5874',
    cursor: 'pointer',
    display: 'flex',
    padding: 0,
    flexShrink: 0,
  },
};
